import React from 'react';

export default function StarRating({ value = 0, count = 0, size = 18, onClick }) {
  const ratingNum = Number(value);
  const safeRating = Number.isFinite(ratingNum) ? ratingNum : 0;

  const totalCount = Number(count) || 0;
  const hasReviews = totalCount > 0;
  const displayRating = safeRating.toFixed(1);

  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        background: 'transparent',
        border: 'none',
        padding: 0,
        cursor: onClick ? 'pointer' : 'default',
      }}
      title={hasReviews ? `${displayRating} / 5 (${totalCount})` : 'Nessuna recensione'}
    >
      <span style={{ color: hasReviews ? '#f1b400' : '#ccc', fontSize: size, lineHeight: 1 }}>
        ★
      </span>
      <span style={{ fontSize: 13, color: '#555' }}>
        {hasReviews ? `${displayRating} (${totalCount})` : '(nessuna recensione)'}
      </span>
    </button>
  );
}
